import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'sera-audit',
    templateUrl: './sera-audit.component.html',
    styleUrls: ['./sera-audit.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SeraAuditComponent {
    @Input()
    title?: string;

    @Input()
    createdBy?: string;

    @Input()
    creationDate?: number;

    @Input()
    changedBy?: string;

    @Input()
    changedDate?: number;

    @Input()
    hideChanged: boolean | null = false;

    @Input()
    hideLastAnnual: boolean | null = false;

    @Input()
    lastAnnualReviewer?: string;

    @Input()
    lastAnnualReviewDate?: number;

    @Input()
    workplaceNumbersZeus?: string;

    @Input()
    choiceWorkplaceAssessment?: string;

    @Input()
    isToShowZeusInfo: boolean = false;

    @Input()
    isToShowHazardIdentification: boolean = false;

    @Input()
    isToShowHeaderDataInfo: boolean = false;

    @Input()
    hazardIdentification?: string;

    @Input()
    styleComp?: {};

    constructor() {}
}
